/* tslint:disable */
/* eslint-disable */
// Kézzel karbantartva: Backend.Core.Infrastructure.Aggregates.App.IssueReportSeverity (hibajelzés súlyossága)
export enum IssueReportSeverity {
  Low = 10,
  Normal = 20,
  High = 30,
  Blocking = 40
}
